import type { OnboardingStats } from '@/api/onboardingChecklist';

const STAT_LABELS: [key: string, singular: string, plural: string][] = [
  ['general_ledger', 'GL file', 'GL files'],
  ['chart_of_accounts', 'chart of accounts', 'chart of accounts'],
  ['invoice', 'invoice', 'invoices'],
  ['returns', 'return', 'returns'],
  ['other', 'other file', 'other files'],
];

/** "1 GL file · 12 invoices · 3 notes" — non-zero counts only, in
 *  vocabulary order, notes last. Empty state gets a friendly zero. */
export function checklistStatsLine(stats: OnboardingStats): string {
  const parts: string[] = [];
  for (const [key, singular, plural] of STAT_LABELS) {
    const count = stats.files_by_category[key] ?? 0;
    if (count > 0) parts.push(`${count} ${count === 1 ? singular : plural}`);
  }
  if (stats.notes > 0) parts.push(`${stats.notes} ${stats.notes === 1 ? 'note' : 'notes'}`);
  if (parts.length === 0) return 'Nothing uploaded yet';
  return parts.join(' · ');
}
